export default __webpack_public_path__ + "images/failed-payment.3a2eaca9ab0b073e5589b71670add4e3.png";